import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing,
  palette
}) => ({
  title: {
    borderBottom: `1px solid ${palette.divider}`
  },
  buttonRoot: {
    minWidth: spacing(5),
    paddingLeft: spacing(.5),
    paddingRight: spacing(.5)
  },
  iconRoot: {
    marginLeft: spacing()
  },
  circularProgressRoot: {
    marginLeft: spacing(1.5),
    position: 'relative',
    top: spacing(.5)
  }
}));
